import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type {
	AiSuggestionsPlugin,
} from '../aiSuggestionsPluginType';
import { getInversion } from '../ui/utils/getInversion';

import type { ShowSuggestionDiffAction } from './types';

export const showSuggestionDiffAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => ShowSuggestionDiffAction = (api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string, options?: { hideDeletedDiffs?: boolean }): boolean => {
		let found = false;
		api?.core?.actions.execute(({ tr }) => {
			const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
			if (!suggestion) {
				return tr;
			}
			found = true;
			const invertedTr = getInversion(tr, suggestion);
			api?.showDiff?.commands.showDiff({
				steps: invertedTr.steps.reverse().map((step) => step.invert(invertedTr.before)),
				originalDoc: invertedTr.doc,
				isInverted: true,
				diffType: 'step',
				hideDeletedDiffs: options?.hideDeletedDiffs,
			})({ tr });
			return tr;
		});
		return found;
	};
